import React from 'react';
import { useI18n } from '../i18n';
import { ArrowRight } from 'lucide-react';

export default function Download({ onConnect }) {
  const { t } = useI18n();
  return (
    <section style={{ padding: '20px 24px 44px' }}>
      <div className="card-surface" style={{ maxWidth: 1000, margin: '0 auto', padding: '48px 32px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(600px 260px at 50% 0%, rgba(59,116,255,0.16), transparent 65%)', pointerEvents: 'none' }} />
        <div style={{ position: 'relative' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
            <img src="/assets/app_icon.png" alt="HITMAX" draggable={false} style={{ width: 96, height: 96, borderRadius: 22, display: 'block', boxShadow: '0 16px 44px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.08)', userSelect: 'none' }} />
          </div>
          <h2 className="font-sora" style={{ margin: 0, fontSize: 'clamp(26px, 4vw, 40px)', fontWeight: 800, letterSpacing: '-0.02em' }}>{t.download.title}</h2>
          <p style={{ margin: '12px auto 0', maxWidth: '52ch', fontSize: 16, color: 'var(--color-neutral-400)', lineHeight: 1.6 }}>{t.download.text}</p>
          <button onClick={onConnect} className="btn-gold" style={{ marginTop: 26, padding: '15px 30px', borderRadius: 12, fontSize: 16, display: 'inline-flex', alignItems: 'center', gap: 8 }}>{t.download.cta} <ArrowRight size={17} /></button>
        </div>
      </div>
    </section>
  );
}
